import { render, staticRenderFns } from "./price-category-list.vue?vue&type=template&id=17f5f430"
import script from "./price-category-list.vue?vue&type=script&lang=js"
export * from "./price-category-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxModal: require('/home/ubuntu/complete-nuxt-js/components/tax-modal.vue').default})
